/**
 * The canonical origin, in the one place that both the app bundle and the build
 * pipeline can read it.
 *
 * `src/lib/env.ts` (browser) and `vite.config.ts` (Node) both go through
 * `normalizeSiteUrl` so canonical links, OG URLs, the sitemap and robots.txt
 * can never disagree about the host — or about the trailing slash, which is the
 * bug this file exists to prevent: `<Seo>` builds URLs as `${site}${path}`, so a
 * VITE_SITE_URL ending in `/` yields `https://host//legal/privacy`.
 *
 * This module is deliberately dependency-free (see also `static-routes.ts`) so
 * `vite.config.ts` can import it — it is compiled by BOTH tsconfig.app.json and
 * tsconfig.node.json.
 */

/** Production origin. Overridden per deploy by VITE_SITE_URL. */
export const DEFAULT_SITE_URL = 'https://service.lucycare.co.kr';

/** Strip trailing slashes and whitespace; fall back to the production origin. */
export function normalizeSiteUrl(raw: string | undefined): string {
  const value = raw?.trim().replace(/\/+$/, '');
  if (!value) return DEFAULT_SITE_URL;
  return value;
}
